import { fetchFastApi } from "../../api/fastapi";
import { useHookCacheQuery } from "../../lib/hookCache";
import {
  ProcedureSessionDocumentsResponse,
  procedureSessionDocumentsResponseSchema,
} from "../../models/audit/auditSession";

/**
 * Hook for the new Phase 2 documents-slice endpoint:
 * `GET /controls/v2/procedure-session/{id}/documents`.
 *
 * Each document carries a denormalised `sampleNumbers` list so the FE
 * doesn't need to stitch documents back to their samples.
 */
export function useProcedureSessionDocuments(
  procedureSessionId: string | undefined,
) {
  return useHookCacheQuery<ProcedureSessionDocumentsResponse>({
    key: ["procedure-session", procedureSessionId ?? "", "documents"],
    fetcher: async () => {
      const response = await fetchFastApi({
        method: "GET",
        path: `/controls/v2/procedure-session/${procedureSessionId}/documents`,
      });
      return procedureSessionDocumentsResponseSchema.parse(response);
    },
    enabled: !!procedureSessionId,
  });
}
